import View from '../../../View'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import PanelContainer from '../../../components/PanelContainer'
import WorkAssignmentComponent from './components/WorkAssignmentComponent'
import {isLoading, isNeedToLoadData, isShown} from './selectors'
import {closePanel, loadWorkAssignmentPanelDataAction} from "./actions"
import LoadingContainer from "../../../util/LoadingContainer";
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from "../../../panels/constants";
import {closeAllPanels} from '../common/actions'

class WorkAssignmentPanel extends View {
    constructor({
        onPanelHide = () => {},
        loadPanel = () => {},
        closeAllPanels = () => {},
    }) {
        super()

        this.state = {
            isShown: false,
            loading: false,
            needToLoadData: null,
        }

        this.onPanelHide = onPanelHide;
        this.loadPanel = loadPanel;
        this.closeAllPanels = closeAllPanels;

        this.onStatePropertyChanged('loading', loading => {
            this.loadingContainer.setState({loading: loading})
        })
        this.onStatePropertyChanged('isShown', isShown => {
            this.panelContainerWrapper.setState({isShown})
        })
        this.onStatePropertyBecameTrue('needToLoadData', () => {
            this.loadPanel()
        })
    }

    afterRender() {
        this.component =  new WorkAssignmentComponent()
        this.loadingContainer = new LoadingContainer({
            contentComponent: this.component,
            containerClass: "loading_workAssignmentPanel",
            contentClass: "loading_workAssignmentPanel_content",
            loadingMoireConfig: {
                delay: 100
            },
        })
        this.panelContainerWrapper = new PanelContainer({
            component: this.loadingContainer,
            additionalClass: 'workAssignment_panel',
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            hideOnEsc: true,
            showHideButton: true,
            onHideCallback: () => this.onPanelHide(),
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: PANEL_TYPES.WORK_ASSIGNMENTS_PANEL,
            },
            hideHandler: () => this.panelContainerWrapper.setState({isShown: false}),
            onClickCloseButton: () => this.closeAllPanels(),
        })
        this.panelContainerWrapper.init(this.$containerEl)
    }
}

export default connect(
    state => ({
        isShown: isShown(state),
        needToLoadData: isNeedToLoadData(state),
        loading: isLoading(state),
    }),
    dispatch => ({
        onPanelHide: bindActionCreators(closePanel, dispatch),
        loadPanel: bindActionCreators(loadWorkAssignmentPanelDataAction, dispatch),
        closeAllPanels: bindActionCreators(closeAllPanels, dispatch),
    }),
)(WorkAssignmentPanel)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/WorkAssignmentPanel.js